import React from 'react'
import DesignCodes from './DesignCodes'

export default ({ ...props }) => <DesignCodes {...props} />
